<template>
    <div>
        <Navigation />
        <section class="section__container spacer-8">

            <h1 class="title center__text">Stagiaire en Marketing Digital Pré-Embauche</h1>
            <div class="requirements container">
                <p class="requirements__title">Vous aspirez à rejoindre une entreprise de premier plan dans le domaine 
                    des solutions de messagerie mobile, caractérisée par son dynamisme et son énergie. 
                    Vous recherchez une variété de missions, une perspective globale de votre profession, 
                    ainsi que l'opportunité de prendre des décisions stratégiques.
                </p>
                <p class="requirements__title">Vous avez une réelle passion pour votre métier et êtes à la recherche 
                    d'une opportunité de stage pré-embauche qui vous permettra de progresser tant en termes de 
                    responsabilités que de rémunération. Si cela correspond à vos aspirations, nous serions ravis 
                    de vous accueillir dans notre aventure !
                </p>
                <h3 class="requirements__title">Missions</h3>
                <p class="requirements__title">Contribuer à la réalisation du plan d'acquisition B2C en marketing
                     pour soutenir la croissance des activités commerciales de l'entreprise :
                </p>
                <ul>
                    <li>Favoriser la notoriété en ligne de l'entreprise en animant ses communautés sur les plateformes telles que Facebook, Instagram, Twitter, LinkedIn, etc.</li>
                    <li>Assumer la responsabilité de la création des supports de communication</li>
                    <li>Élaborer du contenu pour le site internet, les blogs et les réseaux sociaux</li>
                    <li>Soutenir l'équipe de vente dans ses interactions avec les médias</li>
                    <li>Surveiller le suivi des clients et analyser leurs besoins et leurs attentes</li>
                </ul>
                <h3 class="requirements__title">Expérience </h3>
                <ul>
                    <li>Maîtrise avancée du français et/ou de l'anglais (la maîtrise des deux est un plus).</li>
                    <li>Diplôme de niveau Bac+2/3 en communication, marketing et/ou publicité</li>
                    <li>Une première expérience serait un avantage</li>
                    <li>Excellentes compétences relationnelles et solides connaissances techniques dans le domaine du web</li>
                    <li>Aptitude à utiliser le Pack Office</li>
                    <li>Excellentes compétences rédactionnelles</li>
                </ul>
                <h3 class="requirements__title">Compétences recherchées</h3>
                <ul>
                    <li>Capacité d'organisation et rigueur inébranlable</li>
                    <li>Aptitude à établir de bonnes relations</li>
                    <li>Polyvalence</li>
                    <li>Autonomie</li>
                    <li>Esprit d'initiative</li>
                </ul>
                <h3 class="requirements__title">Conditions</h3>
                <ul>
                    <li>Date de début : Dès que possible</li>
                    <li>Rémunération mensuelle : Composée d'un salaire de base et de primes <br/>(Stage d'une durée de 6 mois)</li>
                    <li>En cas de succès durant le stage, une véritable possibilité d'embauche sera envisagée</li>
                </ul>
                <div class="other__requirements">
                    <h3>Comment postuler ?</h3>
                    <p>Pour candidater à ce poste, veuillez inclure votre CV en l'attachant à un e-mail adressé à

                        <a href="mailto:recrutement@servicesms.sn">recrutement@servicesms.sn</a>
                        , en utilisant comme objet " Stagiaire en Marketing Digital Pré-Embauche".
                    </p>

                </div>

            </div>
        </section>
        <Footer />
    </div>
</template>

<script>
import Navigation from './Navigation';
import Footer from './Footer';
export default {
    components: {
        Navigation,
        Footer
    }
}
</script>

<style lang="scss" scoped>
@import '../assets/base.scss';

.requirements {
    box-shadow: 0 67px 139px 28px rgba(0, 0, 0, .05);
    border-radius: 25px 25px 25px 0;
    
}

.requirements__title {
    padding-left: 2rem;
    padding-top: 1rem;
}

.other__requirements {
    padding-left: 1rem;
    padding-bottom: 4rem;
}

li {
    list-style-type: none;
}

li::before {
    content: "";
    width: 15px;
    height: 15px;
    background: url(../../public/images/picto-list.svg) no-repeat center;
    padding-left: 2rem;
}

@media(min-width: 65rem) {
    .requirements {
        width: 60%;
        margin: 3rem auto;
    }

    .spacer-8 {
        margin-top: 8rem;
    }
    .title{
        padding-top: 3rem;
    }
}</style>